export const serviceURL = "https://rp-prod.hooli.la/hooli-rp/RPServices";
export const serviceURLHooli = "https://rp-prod.hooli.la/hooli-rp/RPServices";
